export default __webpack_public_path__ + "static/media/jc.838327d0.svg";